// ★★ A DATA EM QUE O LEAD SE ENCERROU SEM VENDA — uma definição, um arquivo.
//
// Módulo NEUTRO de propósito: não importa `@/` nada, só o vizinho
// `contagemComparecimento.js` (que também é neutro). Isso é o que permite ele
// ser importado pelos DOIS mundos que precisam da regra:
//
//   - o navegador, por `web/src/dashboard/analise.js` (o funil e os painéis);
//   - o Admin SDK, por `scripts/gravar-comparecimentos-retroativos.js`,
//     que importa por caminho relativo (`../web/src/leads/dataDesfecho.js`),
//     como `atribuir-sdr-leads.js` e `preencher-resgates-importados.js` já fazem.
//
// ⚠ POR QUE ELE EXISTE: no Bloco D o script tinha a precedência
// `desfechoNegativoEm → atualizadoEm` e o Dashboard tinha
// `motivoNaoFechouEm → desfechoNegativoEm`. Duas regras para a MESMA data. Em
// produção `desfechoNegativoEm` estava vazio em 100% dos `nao_fechou` (0 de 64),
// então o script caía na reserva `atualizadoEm` — a data da última EDIÇÃO da
// ficha, que anda sozinha a cada correção de telefone. Os meses batiam por
// sorte, não por regra.
//
// É o mesmo remédio do comparecimento: em vez de espelhar e comparar, a casa
// passa a ter UM lugar onde a regra mora.

import { paraData } from './contagemComparecimento.js';

/**
 * Quando o lead se encerrou sem venda, e DE ONDE a data veio.
 *
 * Cada etapa negativa tem seu carimbo próprio, gravado na hora de mover; o
 * `desfechoNegativoEm` é a reserva comum. Ler o carimbo, e não a config de
 * motivos, é o que impede um clique do gestor em Configurações de reescrever
 * agosto.
 *
 * `nao_compareceu` não tem carimbo no lead: a data é a FALTA mais recente, que
 * só quem tem os agendamentos em mão sabe calcular — por isso ela entra por
 * parâmetro (`faltaDoLead`) em vez de o módulo ir buscá-la.
 *
 * Devolve `{ data, fonte }`. A `fonte` não é enfeite: é o que o dry-run do
 * script conta separadamente, e foi ela que revelou os 64 na reserva.
 *
 * Etapa viva ou `fechado` → `{ data: null }`: não houve encerramento negativo.
 */
export function dataDoDesfechoNegativo(lead, faltaDoLead = null) {
  const proprio = (() => {
    if (lead?.etapa === 'nao_agendou') return { d: paraData(lead.motivoNaoAgendouEm), f: 'motivoNaoAgendouEm' };
    if (lead?.etapa === 'nao_fechou') return { d: paraData(lead.motivoNaoFechouEm), f: 'motivoNaoFechouEm' };
    if (lead?.etapa === 'nao_compareceu') return { d: paraData(faltaDoLead), f: 'faltaMaisRecente' };
    return null;
  })();
  // Fora das três etapas negativas não há desfecho — nem a reserva vale.
  if (!proprio) return { data: null, fonte: 'nenhuma' };
  if (proprio.d) return { data: proprio.d, fonte: proprio.f };
  const reserva = paraData(lead?.desfechoNegativoEm);
  if (reserva) return { data: reserva, fonte: 'desfechoNegativoEm' };
  return { data: null, fonte: 'nenhuma' };
}
